/**
 * Check if a URL points to a 3D model file (GLB/glTF-binary).
 * Strips query params before checking extension.
 */
export function is3DModelUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  // Strip query string and fragment before checking extension
  const path = url.split('?')[0].split('#')[0];
  return path.toLowerCase().endsWith('.glb');
}

/**
 * Check if an NFT is a 3D model.
 * Checks media_type first (reliable, from database), then falls back to URL extension.
 * This handles IPFS URLs that don't have file extensions.
 */
export function is3DModel(nft: { media_type?: string | null; media_url?: string | null; thumbnail_url?: string | null; image_url?: string | null }): boolean {
  if (nft.media_type === 'model/gltf-binary') return true;
  return is3DModelUrl(nft.media_url || nft.thumbnail_url || nft.image_url);
}

/**
 * Convert a CloudFront CDN URL to a CORS-friendly URL for model-viewer.
 *
 * model-viewer uses fetch() internally to load 3D models, which is subject to
 * CORS policy (unlike <img> tags). In development, this rewrites CloudFront URLs
 * to go through Vite's proxy, avoiding CORS issues.
 *
 * In production, S3/CloudFront CORS headers must be configured to allow the
 * frontend origin.
 */
export function getModelViewerUrl(url: string): string {
  if (import.meta.env.DEV) {
    const match = url.match(/^https?:\/\/[^/]*cloudfront\.net(\/.*)/);
    if (match) {
      return '/cdn-proxy' + match[1];
    }
  }
  return url;
}
